// HomeLiveStreamFeed.js
'use strict';
import { connect } from 'react-redux';

import getMeData from '../selector/getMeData.js';
import getListData from '../selector/getListData.js';
import getFilterType from '../selector/getFilterType.js';
import getLivestreamFeedSortings from '../selector/getLivestreamFeedSortings.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getHomeLiveStreamIds from '../selector/getHomeLiveStreamIds.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getIsRemoteConfigMerged from '../selector/getIsRemoteConfigMerged.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getFeedRenewData from '../selector/getFeedRenewData.js';
import getSelectedFeedQueryOptions from '../selector/getSelectedFeedQueryOptions.js';
import fetchFeeds from '../action/fetchFeeds.js';
import subscribeFeedChannel from '../action/subscribeFeedChannel.js';
import unsubscribeFeedChannel from '../action/unsubscribeFeedChannel.js';
import setSelectedFeedQueryOption from '../action/setSelectedFeedQueryOption.js';
import sendUserDebugFeedContentError from '../action/sendUserDebugFeedContentError.js';
import { resetSelectedOptions } from '../action/feedFilterActions.js';

import HomeLiveStreamFeed from '../component/HomeLiveStreamFeed.jsx';

import {
  CONFIG_PRIORITY_CONFIGURE,
  CONFIG_PRIORITY_PRESENCE_USER,
  CONFIG_PRIORITY_PRESENCE_CLIENT,
} from '../resource/configPriority.js';
import getIsPermissionMatched from '../selector/getIsPermissionMatched.js';
import { sanitizeFeedQuery } from '../resource/feedUtils.js';
import { QueryType } from '../resource/feedConstants.js';
import {
  LIVESTREAM_FEED,
  JWT_SCOPE_CURATOR,
  FEATURE_LIVESTREAM_FEED_DEDUPE,
} from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { category, hasTopFeed }) => {
  const sanitizedCategory = sanitizeFeedQuery({ feedName: category });
  const filterType = getFilterType(state);
  const isAuthed = !!getMeData(state, 'id');
  const isRemoteConfigMerged = isAuthed
    ? getIsRemoteConfigMerged(state, CONFIG_PRIORITY_PRESENCE_USER)
    : getIsRemoteConfigMerged(state, CONFIG_PRIORITY_PRESENCE_CLIENT) ||
      getIsRemoteConfigMerged(state, CONFIG_PRIORITY_CONFIGURE);
  const livestreamFeed = getRemoteConfigData(state, LIVESTREAM_FEED);
  const livestreamFeedSortings = getLivestreamFeedSortings(state, filterType);
  const { feedNameWithQuery, intersectedFeedName } =
    getSelectedQueryOptionObject(
      state,
      sanitizedCategory,
      getSelectedFeedQueryOptions(state, LIVESTREAM_FEED, undefined),
      livestreamFeedSortings[0]
    );
  const liveStreamSelectPath = ['home', 'users', feedNameWithQuery];
  const userIds = getHomeLiveStreamIds(state, liveStreamSelectPath, hasTopFeed);
  const nextPage = getListData(state, liveStreamSelectPath, 'nextPage');
  const isNextPageFetching = !!getNetworkingData(
    state,
    [...liveStreamSelectPath, nextPage],
    'isFetching'
  );
  const isFirstPageFetching = !!getNetworkingData(
    state,
    [...liveStreamSelectPath, 1],
    'isFetching'
  );
  const isFirstPageFetched = !!getNetworkingData(
    state,
    [...liveStreamSelectPath, 1],
    'isFetched'
  );

  // default feed for padding empty filter result
  const { feedNameWithQuery: defaultFeedNameWithQuery } =
    getSelectedQueryOptionObject(
      state,
      sanitizedCategory,
      [],
      livestreamFeedSortings[0]
    );
  const defaultFeedSelectPath = ['home', 'users', defaultFeedNameWithQuery];
  const defaultUserIds = getListData(state, defaultFeedSelectPath, 'itemIds');
  const defaultNextPage = getListData(state, defaultFeedSelectPath, 'nextPage');
  const isDefaultNextPageFetching = !!getNetworkingData(
    state,
    [...defaultFeedSelectPath, defaultNextPage],
    'isFetching'
  );

  const isCurator = getIsPermissionMatched(state, JWT_SCOPE_CURATOR);
  const isLivestreamFeedDeduped = getRemoteConfigData(
    state,
    FEATURE_LIVESTREAM_FEED_DEDUPE
  );

  return {
    isAuthed,
    isLivestreamFeedDeduped,
    isRemoteConfigMerged,
    category: sanitizedCategory,
    feedNameWithQuery,
    intersectedFeedName,
    renewFeedId: getFeedRenewData(state, intersectedFeedName, 'id'),
    latestFeedRenewUnix: getFeedRenewData(
      state,
      intersectedFeedName,
      'timestamp'
    ),
    totalCount: getListData(state, liveStreamSelectPath, 'totalCount'),
    userIds,
    selectedFilterOptions: getSelectedFeedQueryOptions(
      state,
      LIVESTREAM_FEED,
      QueryType.FILTER
    ),
    nextPage,
    isNextPageFetching,
    isFirstPageFetching,
    isFirstPageFetched,
    defaultFeedNameWithQuery,
    defaultUserIds,
    defaultNextPage,
    isDefaultNextPageFetching,
    hasDefaultFeedFetched: getNetworkingData(
      state,
      [...defaultFeedSelectPath, 1],
      'isFetched'
    ),
    feedRenewObject: getFeedRenewData(state, intersectedFeedName),
    shouldUseCuratorMode: isCurator,
    livestreamFeed,
    livestreamFeedSortings,
    filterType,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: payload => dispatch(fetchFeeds(payload)),
    subscribeFeedChannel: ({ feedName }) =>
      dispatch(subscribeFeedChannel({ feedName })),
    unsubscribeFeedChannel: ({ feedName }) =>
      dispatch(unsubscribeFeedChannel({ feedName })),
    setSelectedFeedQueryOption: payload =>
      dispatch(setSelectedFeedQueryOption(payload)),
    sendUserDebugFeedContentError: payload =>
      dispatch(sendUserDebugFeedContentError(payload)),
    resetSelectedOptions: payload => dispatch(resetSelectedOptions(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeLiveStreamFeed);
